import {Component, OnInit} from '@angular/core';
import {Router, ActivatedRoute, Params} from '@angular/router';
import {InventoryService} from './inventory.service';
import {AppComponent} from './app.component';

import {SortTable} from './sort-table.component';
import {Sort} from '@angular/material';

@Component({
    selector: 'inventory-analysis',
    templateUrl: './templates/inventory-analysis.component.html',
    styleUrls: ['./styles/inventory-analysis.component.css'],
    providers: [InventoryService, SortTable]
})
export class InventoryAnalysisComponent implements OnInit {

    article_selected_list: Array<string> = [];
    article_list: Array<string> = [];
    art_list: Array<any>;
    empty_list: boolean = true;
    id_stocktaking: any;
    sortedDataArtcile: any = [];
    terminated: boolean = true;
    selected_tr: any;
    showconfirmation: boolean = false;
    pop_up_msg: any = "";
    pop_up_action: any;
    disabled_adjustment: boolean = false;
    ref_inv: any;
    date_inv: any;
    name_inv: any;
    empty_art_list: boolean = true;

    constructor(private activated_route: ActivatedRoute,
        private inventory_service: InventoryService,
        private sort_table: SortTable,
        private app_component: AppComponent,
        private router: Router
    ) {
        this.app_component.valTest = '/inventory-analysis';
        this.app_component.GetParent();
        this.GetStocktakingInfos_cb();
    }


    GetStocktakingInfos_cb(): void {
        this.activated_route.params.subscribe((params: Params) => {
            let id = params['id_stocktaking'];
            this.id_stocktaking = id;
            if (id !== undefined) {
                this.inventory_service.LoadStockTakingArticleAnalyse(id).then(result => {

                    let list = result['list'];
                    this.art_list = result['list'];
                    this.article_list = result['list'];
                    this.sortedDataArtcile = result['list'];

                    this.ref_inv = result['list'][0]['reference'];
                    this.date_inv = result['list'][0]['starting_time'];
                    this.name_inv = result['list'][0]['name'];

                    this.CanTerminated(result['list']);
                    this.CanRecount(result['list']);
                    //console.log(this.terminated);
                });
            }
            else {
                this.terminated = false;
            }
        });
    }

    CanTerminated(list: any): void {
        this.terminated = true;
        let compteur = 0;
        for (let i = 0; i < list.length; i++) {
            if (parseInt(list[i]['quantity_inventaire']) !== parseInt(list[i]['quantity_stock'])) {
                //console.log(list[i]);
                this.selected_tr = i;
                this.terminated = false;
                this.Exists(list[i]['id_article'], this.article_selected_list);
                this.Toggle(list[i]['id_article'], this.article_selected_list);
                compteur = compteur + 1;
            }
        }

        //console.log(compteur);
        if (compteur === 0) {
            this.pop_up_action = "Pre_finish";
            this.pop_up_msg = "Cliquer sur terminer pour valider l'inventaire";
            this.showconfirmation = true;
            this.app_component.hide_wrapper(this.showconfirmation);
        }
    }

    CanAdjust(list: any): void {
        this.disabled_adjustment = true;
        this.article_selected_list = [];
        for (let i = 0; i < list.length; i++) {
            if (parseInt(list[i]['quantity_inventaire']) === parseInt(list[i]['quantity_stock'])) {
                if (list[i]['state'] !== 'ADJUSTED') {
                    //console.log(list[i]);
                    this.selected_tr = i;
                    this.disabled_adjustment = false;

                }
            } else {
                this.Exists(list[i]['id_article'], this.article_selected_list);
                this.Toggle(list[i]['id_article'], this.article_selected_list);
            }

        }
    }

    disabled_recount: boolean = true;
    CanRecount(list: any): void {
        this.disabled_recount = true;
        for (let i = 0; i < list.length; i++) {
            if (list[i]['state'] !== 'ADJSUTED') {
                console.log(i);
                console.log(list[i]['state']);
                this.selected_tr = i;
                this.disabled_recount = false;
            }
        }
    }

    DialogBox(): void {
        this.showconfirmation = true;
        this.app_component.hide_wrapper(this.showconfirmation);
    }

    BtPopFunction(): void {
        //this.router.navigate(['inventories']);
        if (this.pop_up_action === "Finish") {
            console.log('TERMINE');
            this.inventory_service.FinishedStocktaking(this.id_stocktaking).then(result => {
                this.router.navigate(['inventories']);
            });
        } else if (this.pop_up_action === "Pre_finish") {

        } else {
            let list = this.article_selected_list.join("_");
            this.inventory_service.Recount(this.id_stocktaking, list, 'ADJUST').then(result => {
                //console.log(result);
                //this.router.navigate(['inventory-capture', {id_stocktaking: result['id_stocktaking']}]);
                this.sortedDataArtcile = result['list'];
                this.CanTerminated(result['list']);
                this.CanAdjust(result['list']);
                this.CanRecount(result['list']);
            });
            // console.log('ADJUST');
        }
        this.DialogCancel();
    }

    FinishedStocktaking(): void {
        this.pop_up_msg = "Voulez-vous vraiment terminer l'inventaire ?";
        this.pop_up_action = "Finish";

        this.DialogBox();
    }

    AdjustStocktaking(): void {
        this.pop_up_msg = "Voulez-vous vraiment procéder à l'ajustement ?";
        this.pop_up_action = "Adjust";

        this.DialogBox();
    }

    DialogCancel(): void {
        this.showconfirmation = false;
        this.app_component.hide_wrapper(this.showconfirmation);
        //this.Reset();
    }

    Color(index: number) {

        let styles = {
            'color': 'black',
        };
        if (this.selected_tr === index) {
            styles = {

                'color': 'red',//'#FFB400',
                //'color': 'orange',
            };
        }

        return styles;
    }

    SortArticles(sort: Sort): void {
        this.sort_table.SetDataArray(this.art_list, [{value: "article", type: ""}, {value: "cat", type: ""}, {value: "internal_code", type: ""}, {value: "supplier_code", type: ""}, {value: "stock_th", type: "number"}, {value: "stock_rl", type: "number"}, {value: "stock_ec", type: "number"}]);
        this.sort_table.sortData(sort);
        this.sortedDataArtcile = this.sort_table.GetSortData();
        // recupérer  data
    }

    isChecked(): boolean {
        return this.article_selected_list.length === this.article_list.length;
    }

    isIndeterminate(): boolean {
        return (this.article_selected_list.length !== 0 &&
            this.article_selected_list.length !== this.article_list.length);

    }

    toggleAll(): void {

        if (this.article_selected_list.length === this.article_list.length) {
            this.article_selected_list = [];
            this.empty_list = true;
        } else if (this.article_selected_list.length === 0 || this.article_selected_list.length > 0) {
            this.empty_list = false;
            for (let i = 0; i < this.article_list.length; i++) {
                this.article_selected_list[i] = this.article_list[i]['id_article'];

            }
        }
        // this.quantity = this.article_selected_list.length;
    }

    Exists(id_article: string, selected: Array<string>): boolean {
        return selected.indexOf(id_article) > -1;
    }

    Toggle(id_article: string, selected: Array<string>): void {
        this.empty_list = false;

        var index = selected.indexOf(id_article);
        if (index > -1) {
            selected.splice(index, 1);
        }
        else {
            selected.push(id_article);
        }
        if (this.article_selected_list.length === 0) {
            this.empty_list = true;
        }
        //this.quantity = selected.length;
    };

    Recount(): void {
        //console.log(this.article_selected_list);
        let list = this.article_selected_list.join("_");
        this.inventory_service.Recount(this.id_stocktaking, list, 'RECOUNT').then(result => {
            //console.log(result);
            this.router.navigate(['inventory-capture', {id_stocktaking: result['id_stocktaking']}]);

        });
    }

    ngOnInit() {
    }

}



// WEBPACK FOOTER //
// ./src/app/inventory-analysis.component.ts